/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";
import { CSVLink } from "react-csv";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
  getPaginationRowModel,
  getFilteredRowModel,
  getFacetedMinMaxValues,
} from "@tanstack/react-table";
import { Form } from "react-bootstrap";

// const pageSizes = [10, 20, 30, 40, 50];

/**
 * 
   column option to disable filter  : enableColumnFilter: false
   my custom filterFn : datePeriod , customEqual (you can add new custom fitters at filterFn object)
    filterInputInfo: {
          type: "date", "select" , "number" , "numberPeriod"
          if select => options: []
      },

 */

function Filter({ column }) {
  const columnFilterValue = column.getFilterValue();
  if (!column.getCanFilter() || !column.columnDef?.filterInputInfo) return null;
  if (
    !column.columnDef?.filterInputInfo?.type ||
    column.columnDef?.filterInputInfo?.type === "string"
  )
    return (
      <Form.Group
        className="input input-md"
        controlId={column.columnDef.header}
      >
        <Form.Label>
          {column.columnDef?.filterInputInfo?.label || column.columnDef.header}
        </Form.Label>
        <Form.Control
          type="text"
          value={columnFilterValue || ""}
          onChange={(e) => column.setFilterValue(e.target.value)}
          placeholder={column.columnDef?.filterInputInfo?.placeholder || ""}
        />
      </Form.Group>
    );
  if (column.columnDef?.filterInputInfo?.type === "select") {
    const selectOptions = column.columnDef?.filterInputInfo?.selectOptions;
    return (
      <Form.Group className="input input-md" controlId="">
        <Form.Label>
          {column.columnDef?.filterInputInfo?.label || column.columnDef.header}
        </Form.Label>
        <Form.Select
          onChange={(e) => {
            column.setFilterValue(e.target.value);
            const extraAction = column.columnDef?.filterInputInfo?.extraAction;
            if (extraAction) {
              extraAction(e);
            }
          }}
          // multiple="multiple"
        >
          <option value="">All</option>
          {column.columnDef?.filterInputInfo?.options.map((option) => (
            <option
              key={option[selectOptions.value]}
              value={option[selectOptions.value]}
            >
              {option[selectOptions.name]}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    );
  }
  if (
    !column.columnDef?.filterInputInfo?.type ||
    column.columnDef?.filterInputInfo?.type === "number"
  )
    return (
      <Form.Group
        className="input input-md"
        controlId={column.columnDef.header}
      >
        <Form.Label>
          {column.columnDef?.filterInputInfo?.label || column.columnDef.header}
        </Form.Label>
        <Form.Control
          type="number"
          value={columnFilterValue || ""}
          onChange={(e) => {
            column.setFilterValue(
              e.target.value ? parseInt(e.target.value, 10) : null
            );
          }}
        />
      </Form.Group>
    );
  if (column.columnDef?.filterInputInfo?.type === "date")
    return (
      <>
        <Form.Group
          className="input input-md date-input"
          controlId={`${column.columnDef.header}-from`}
        >
          <Form.Label>
            {column.columnDef?.filterInputInfo?.label ||
              column.columnDef.header}{" "}
            (From)
          </Form.Label>
          <Form.Control
            type="date"
            value={columnFilterValue?.[0] || ""}
            onChange={(e) =>
              column.setFilterValue((old) => [e.target.value, old?.[1] || ""])
            }
          />
        </Form.Group>
        <Form.Group
          className="input input-md date-input"
          controlId={`${column.columnDef.header}-to`}
        >
          <Form.Label>
            {column.columnDef?.filterInputInfo?.label ||
              column.columnDef.header}{" "}
            (To)
          </Form.Label>
          <Form.Control
            type="date"
            value={columnFilterValue?.[1] || ""}
            onChange={(e) =>
              column.setFilterValue((old) => [old?.[0] || "", e.target.value])
            }
          />
        </Form.Group>
      </>
    );
  if (column.columnDef?.filterInputInfo?.type === "numberPeriod")
    return (
      <div className="table__filter__period">
        <Form.Group
          className="input input-md"
          controlId={`${column.columnDef.header}-from`}
        >
          <Form.Label>
            {column.columnDef?.filterInputInfo?.label ||
              column.columnDef.header}{" "}
            (From)
          </Form.Label>
          <Form.Control
            type="number"
            value={columnFilterValue?.[0] || ""}
            onChange={(e) =>
              column.setFilterValue((old) => [
                Number(e.target.value),
                old?.[1] || "",
              ])
            }
          />
        </Form.Group>
        <Form.Group
          className="input input-md"
          controlId={`${column.columnDef.header}-to`}
        >
          <Form.Label>
            {column.columnDef?.filterInputInfo?.label ||
              column.columnDef.header}{" "}
            (To)
          </Form.Label>
          <Form.Control
            type="number"
            value={columnFilterValue?.[1] || ""}
            onChange={(e) =>
              column.setFilterValue((old) => [
                old?.[0] || "",
                e.target.value ? Number(e.target.value) : "",
              ])
            }
          />
        </Form.Group>
      </div>
    );

  return null;
}

function Table(props) {
  const { columns, data, exportName, exportColumns } = props;

  // const paginationPageNum = useRef([5, 10, 20, 30, 40, 50]);
  // const data = React.useMemo(() => tableData, [tableData]);

  // const columns = React.useMemo(() => headers, [tableData]);
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
    initialState: {
      pagination: {
        pageSize: 10,
      },
    },
    filterFns: {
      datePeriod: (rows, columnIds, filterValue) => {
        const oneDayInMs = 86400000;
        const rowDate = new Date(rows.original[columnIds]).getTime();
        const fromDate = new Date(filterValue[0]).getTime();
        const toDate = new Date(filterValue[1]).getTime() + oneDayInMs;
        // if we don't have any value to compare return
        if ((!fromDate && !toDate) || !rows.original[columnIds]) return true;
        // only "from" input case
        if (fromDate && !toDate && rowDate >= fromDate) {
          return true;
        }
        // only "to" input case
        if (!fromDate && toDate && rowDate <= toDate) {
          return true;
        }
        // period input cases
        // if user entered inputs in opposite order
        if (
          fromDate &&
          toDate &&
          toDate < fromDate &&
          rowDate <= fromDate &&
          rowDate >= toDate
        ) {
          return true;
        }
        // if user entered right inputs
        if (fromDate && toDate && rowDate <= toDate && rowDate >= fromDate) {
          return true;
        }

        return false;
      },
      customEqual: (rows, columnIds, filterValue) => {
        if (!filterValue) return true;
        const rowValue = rows.original[columnIds];
        // if found the value then return true
        // eslint-disable-next-line eqeqeq
        if (filterValue == rowValue) return true;
        // else
        return false;
      },
    },
  });
  return (
    <div className="table_container">
      {table.getRowModel().rows?.length ? (
        <CSVLink
          data={data}
          target="_blank"
          filename={`${exportName}.csv`}
          className="table__export"
          headers={exportColumns}
        >
          <i className="fa-solid fa-file-arrow-down clickable" key="export" />
        </CSVLink>
      ) : null}
      {data && (
        // <div>{headerGroup.id}</div>
        <>
          <div className="table__filter">
            {table
              .getHeaderGroups()
              .map((headerGroup) =>
                headerGroup.headers.map((header) => (
                  <Filter column={header.column} />
                ))
              )}
          </div>
          <table className="table mt-3">
            <thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <th key={header.id} colSpan={header.colSpan}>
                      {header.isPlaceholder ? null : (
                        <div>
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                        </div>
                      )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows?.length ? (
                table.getRowModel().rows.map((row) => (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                      <td
                        key={cell.id}
                        className={cell.column.columnDef.cellClass || ""}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <td
                  className="text-center"
                  style={{
                    fontSize: "18px",
                    width: "100%",
                  }}
                  colSpan={columns.length}
                >
                  No Records Found
                </td>
              )}
            </tbody>
          </table>
          <div className="pagination">
            <button
              type="button"
              onClick={() => table.setPageIndex(0)}
              disabled={!table.getCanPreviousPage()}
            >
              {"<<"}
            </button>
            <button
              type="button"
              onClick={() => table.previousPage()}
              disabled={!table.getCanPreviousPage()}
            >
              {"<"}
            </button>
            {/* indexed buttons */}
            {/* {table.getState().pagination.pageIndex + 3} */}
            {table.getState().pagination.pageIndex < 3 ? (
              <>
                <button
                  type="button"
                  className={
                    table.getState().pagination.pageIndex === 0
                      ? "active"
                      : undefined
                  }
                  onClick={() => table.setPageIndex(0)}
                >
                  1
                </button>
                {table.getPageCount() > 1 && (
                  <button
                    type="button"
                    className={
                      table.getState().pagination.pageIndex === 1
                        ? "active"
                        : undefined
                    }
                    onClick={() => table.setPageIndex(1)}
                  >
                    2
                  </button>
                )}
                {table.getPageCount() > 2 && (
                  <button
                    type="button"
                    className={
                      table.getState().pagination.pageIndex === 2
                        ? "active"
                        : undefined
                    }
                    onClick={() => table.setPageIndex(2)}
                  >
                    3
                  </button>
                )}
                {table.getPageCount() > 3 && (
                  <button type="button" onClick={() => table.setPageIndex(3)}>
                    4
                  </button>
                )}
                {table.getPageCount() > 4 && (
                  <button type="button" onClick={() => table.setPageIndex(4)}>
                    5
                  </button>
                )}
              </>
            ) : table.getPageCount() -
                (table.getState().pagination.pageIndex + 1) <
              3 ? (
              <>
                {/* table.setPageIndex(0) */}
                <button
                  type="button"
                  onClick={() => table.setPageIndex(table.getPageCount() - 5)}
                >
                  {table.getPageCount() - 4}
                </button>
                <button
                  type="button"
                  onClick={() => table.setPageIndex(table.getPageCount() - 4)}
                >
                  {table.getPageCount() - 3}
                </button>
                <button
                  type="button"
                  className={
                    table.getState().pagination.pageIndex ===
                    table.getPageCount() - 3
                      ? "active"
                      : undefined
                  }
                  onClick={() => table.setPageIndex(table.getPageCount() - 3)}
                >
                  {table.getPageCount() - 2}
                </button>
                <button
                  type="button"
                  className={
                    table.getState().pagination.pageIndex ===
                    table.getPageCount() - 2
                      ? "active"
                      : undefined
                  }
                  onClick={() => table.setPageIndex(table.getPageCount() - 2)}
                >
                  {table.getPageCount() - 1}
                </button>
                <button
                  type="button"
                  className={
                    table.getState().pagination.pageIndex ===
                    table.getPageCount() - 1
                      ? "active"
                      : undefined
                  }
                  onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                >
                  {table.getPageCount()}
                </button>
              </>
            ) : (
              [...Array(5).keys()].map((index) => {
                const { pageIndex } = table.getState().pagination;

                if (index === 0)
                  return (
                    <button
                      type="button"
                      onClick={() => table.setPageIndex(pageIndex - 2)}
                    >
                      {pageIndex - 1}
                    </button>
                  );
                if (index === 1)
                  return (
                    <button
                      type="button"
                      onClick={() => table.setPageIndex(pageIndex - 1)}
                    >
                      {pageIndex}
                    </button>
                  );
                if (index === 2)
                  return (
                    <button
                      type="button"
                      className="active"
                      onClick={() => table.setPageIndex(pageIndex)}
                    >
                      {pageIndex + 1}
                    </button>
                  );
                if (index === 3)
                  return (
                    <button
                      type="button"
                      onClick={() => table.setPageIndex(pageIndex + 1)}
                    >
                      {pageIndex + 2}
                    </button>
                  );
                if (index === 4)
                  return (
                    <button
                      type="button"
                      onClick={() => table.setPageIndex(pageIndex + 2)}
                    >
                      {pageIndex + 3}
                    </button>
                  );
                return null;
              })
            )}
            {/* end indexed buttons */}
            <button
              type="button"
              onClick={() => table.nextPage()}
              disabled={!table.getCanNextPage()}
            >
              {">"}
            </button>
            <button
              type="button"
              onClick={() => table.setPageIndex(table.getPageCount() - 1)}
              disabled={!table.getCanNextPage()}
            >
              {">>"}
            </button>
            {/* <span className="flex items-center gap-1">
        | Go to page:
        <input
          type="number"
          defaultValue={table.getState().pagination.pageIndex + 1}
          onChange={(e) => {
            const page = e.target.value ? Number(e.target.value) - 1 : 0;
            table.setPageIndex(page);
          }}
          className="border p-1 rounded w-16"
        />
      </span>
      <select
        value={table.getState().pagination.pageSize}
        onChange={(e) => {
          table.setPageSize(Number(e.target.value));
        }}
      > */}
            {/* {pageSizes.map((pageSize) => (
          <option key={pageSize} value={pageSize}>
            Show {pageSize}
          </option>
        ))} */}
            {/* </select> */}
          </div>
          <div
            className="d-flex"
            style={{
              justifyContent: "center",
            }}
          >
            <div>
              <strong>
                <span style={{ marginInlineStart: "5px" }}>Page</span>
                {table.getState().pagination.pageIndex + 1} of{" "}
                {table.getPageCount()}
              </strong>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

Table.defaultProps = {
  isPagination: true,
};

Table.prototype = {
  headers: PropTypes.array.isRequired,
  tableData: PropTypes.array.isRequired,
  exportName: PropTypes.string.isRequired,
  exportColumns: PropTypes.array.isRequired,
  setExportData: PropTypes.func.isRequired,
  isPagination: PropTypes.bool,
};
export default Table;
